function range(count: number, start: number = 0, step: number = 1): number[] {
  const nums: number[] = [];

  if (count <= 0) {
    throw new TypeError('count expects a positive integer');
  } else if (step <= 0) {
    throw new TypeError('step expects a positive integer');
  }

  for (let i = 0; i < count; i += step) {
    nums.push(start + i);
  }

  return nums;
}

export function formatDate(date: Date): string {
  // gets yyyy-MM-dd of date
  return date.toISOString().slice(0, 10);
}

export function date(year: number, month: number, day: number): Date {
  return new Date(Date.UTC(year, month - 1, day));
}

export function getWeekDay(date: Date): number {
  // Convert Sun-Mon to Mon-Sun, by default .getDay() returns 0-6 (Sun-Mon).
  return (date.getDay() + 6) % 7;
}

export function getWeekDays(locale: string) {
  const dt = date(1970, 1, 1);
  const offset = dt.getDay() + 1;
  if (offset > 0) {
    dt.setDate(offset);
  }

  const names = [];

  for (let i = 0; i < 7; i++) {
    names.push(dt.toLocaleDateString(locale, { weekday: 'long' }));

    dt.setDate(1 + dt.getDate());
  }

  return names;
}

export function getDaysInMonth(year: number, month: number): number {
  // Get days by incrementing month and subtracting a day
  return date(year, month + 1, 0).getDate();
}

function formatDates(year: number, month: number, days: number[]): string[] {
  return days.map(day => formatDate(date(year, month, day)));
}

export function getCalendarDays(year: number, month: number): string[] {
  const startOffset = getWeekDay(date(year, month, 1));
  const days: string[] = [];

  if (startOffset > 0) {
    const daysInPrev = getDaysInMonth(year, month - 1);
    const nums = range(startOffset, daysInPrev - startOffset + 1);

    days.push(...formatDates(year, month - 1, nums));
  }

  const daysInMonth = getDaysInMonth(year, month);
  days.push(...formatDates(year, month, range(daysInMonth, 1)));

  const endOffset = (days.length % 7);

  if (endOffset > 0) {
    const nums = range(7 - endOffset, 1);

    days.push(...formatDates(year, month + 1, nums));
  }

  return days;
}

export function isDateEqual(self: Date, other: Date): boolean {
  return self.getFullYear() === other.getFullYear()
      && self.getMonth() === other.getMonth()
      && self.getDate() == other.getDate();
}
